export const GET_USER_TOKEN_SUCCESS = 'GET_USER_TOKEN_SUCCESS'
export const INVALID_TOKEN = 'INVALID_TOKEN'
export const SEND_PASSWORD_RESET = 'SEND_PASSWORD_RESET'
